module.exports = __webpack_public_path__ + "static/media/jsqi.e2569aab.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/jsqi.png
// module id = 1791
// module chunks = 0 1